/* ─────────────────────────────────────────────────────────────
   Inner dashboard tabs — converted from the reference design,
   one component per file. DashboardPage renders the selected
   sidebar key through the TAB_COMPONENTS registry below.
   Colours/fonts/spacing mirror the source exactly.
   ───────────────────────────────────────────────────────────── */
import OverviewTab from './OverviewTab'
import AstrologerOverviewTab from './AstrologerOverviewTab'
import StudentOverviewTab from './StudentOverviewTab'
import InstructorOverviewTab from './InstructorOverviewTab'
import InstructorCoursesTab from './InstructorCoursesTab'
import AstrologerProfileTab from './astrologerProfile'
import BecomeAstrologerTab from './becomeAstrologer'
import HoroscopeTab from './HoroscopeTab'
import KundliTab from './KundliTab'
import AstrologerKundliTab from './AstrologerKundliTab'
import ConsultationsTab from './ConsultationsTab'
import EarningsTab from './EarningsTab'
import GoLiveTab from './GoLiveTab'
import BlogAuthoringTab from './blogAuthoring'
import ShopTab from './ShopTab'
import OrdersTab from './OrdersTab'
import PujaBookingsTab from './PujaBookingsTab'
import CoursesTab from './CoursesTab'
import ReportsTab from './ReportsTab'
import RemediesTab from './RemediesTab'
import PricingSettingsTab from './PricingSettingsTab'
import SettingsTab from './SettingsTab'
import SupportTab from './SupportTab'

export { default as PlaceholderTab } from './PlaceholderTab'

/* Sidebar nav key → tab screen. Keys mirror NAV in DashboardPage; keys
   without an entry here (reports, remedies) render the
   PlaceholderTab. Every tab receives `data` (useDashboard), `onSwitch`
   (tab setter), plus `roles` and `role` (primary) for role-based content.

   The sidebar renamed some keys (consultations → appoinments,
   settings → myprofile); the old keys stay registered as aliases so
   in-page buttons (hero "Book Consultation") and shared ?tab= links
   keep working. */
export const TAB_COMPONENTS = {
  overview: OverviewTab,
  horoscope: HoroscopeTab,
  kundli: KundliTab,
  appoinments: ConsultationsTab,
  earnings: EarningsTab,
  // Instant live streaming - astrologer only (roles.js). The camera itself
  // lives in the jyotish app's studio; this tab starts the stream and links to it.
  golive: GoLiveTab,
  // Writing for the public blog - astrologer only (roles.js). The author can
  // reach "waiting for review" and no further; publishing is the admin's.
  blog: BlogAuthoringTab,
  shop: ShopTab,
  orders: OrdersTab,
  pujabookings: PujaBookingsTab,
  courses: CoursesTab,
  reports: ReportsTab,
  remedies: RemediesTab,
  myprofile: SettingsTab,
  // "Become an Astrologer" — the onboarding application for an account that
  // already exists. Whether it appears at all is the admin's call, not a role
  // rule: DashboardPage filters it through useAstrologerOnboarding.
  becomeastrologer: BecomeAstrologerTab,
  settings: SettingsTab, // alias of myprofile (legacy ?tab= links)
  // SPECIAL CASE: sidebar label "Settings" — pricing-slab editor, shown only
  // to EXCLUSIVE_TABS_BY_EMAIL accounts (DashboardPage). Keyed `pricing`
  // because `settings` is the legacy alias above.
  pricing: PricingSettingsTab,
  support: SupportTab,
}

/* Role-specific screens. When a tab renders entirely different content
   for a role (rather than branching internally on the `role` prop),
   register the variant here: TAB_ROLE_COMPONENTS[key][role]. Falls back
   to TAB_COMPONENTS[key]. Filled in as tabs are reworked role by role. */
export const TAB_ROLE_COMPONENTS = {
  overview: {
    astrologer: AstrologerOverviewTab,
    instructor: InstructorOverviewTab,
    student: StudentOverviewTab,
  },
  courses: { instructor: InstructorCoursesTab },
  kundli: { astrologer: AstrologerKundliTab },
  myprofile: { astrologer: AstrologerProfileTab },
  settings: { astrologer: AstrologerProfileTab }, // alias of myprofile
}

/** The component for a tab key given the user's primary role. */
export function resolveTab(key, role) {
  return TAB_ROLE_COMPONENTS[key]?.[role] ?? TAB_COMPONENTS[key] ?? null
}
